<!-- <app-back-button *ngIf="standalone"></app-back-button> -->
<app-viewpoint-map [mode]="'proposed'" [viewpoint]="viewpoint" [viewpoints]="viewpoints"></app-viewpoint-map>
<app-switch [checked]="mode === 'proposed' ? true : false" (check)="toggleMode()"></app-switch>
<app-horizontal-toolbar [toggleBtnTop]="83" [viewpoints]="viewpoints"></app-horizontal-toolbar>